import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome, faFolder } from '@fortawesome/free-solid-svg-icons'

const Header = (props) => {
  const { config } = props
  return (
    <div>
      <div className="header" >
        <a className="btn btn-primary" href={"/"} role="button">
          <FontAwesomeIcon icon={faHome} size="2x" />
          <b>  Home</b>
        </a>

        <img
          src={process.env.PUBLIC_URL + '/Images/Image1.png'}
          alt=""
        />

        <a className="btn btn-primary" href={"http://eliteeuropean2020.veloresults.com"} target="_blank" role="button">
          <FontAwesomeIcon icon={faFolder} size="2x" />
          <b> PDF Files</b>
        </a>

      </div>
    </div>
  )
};

export default Header;